import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FORM_KEYS } from "../../../../../constants";
import { uploadBackgroundImage } from "../../../../../../../store/webdavSlice";
import { getSelfServiceCnameSelector } from "../../../../../../../store/selfServiceSlice";
import FormContext from "../../../../../../../context/formContext";

/**
 * @desc File background handlers.
 */
export const useHandlers = () => {
  const dispatch = useDispatch();
  const cname = useSelector(getSelfServiceCnameSelector);
  const { setValue } = useContext(FormContext);

  // METHODDS -----------------------------------------------------------------

  /**
   * @desc Handle file background change.
   */
  const handleChange = async (e) => {
    const files = e.target.files;
    if (files.length) {
      const file = files[0];
      const fileType = file.name.split(".")[1];
      const form = new FormData();

      // Create Form Data
      form.append("image", file);
      form.append("filename", `${cname}-background-${Date.now()}.${fileType}`);

      // Upload to WebDav, Update Form
      const response = await dispatch(uploadBackgroundImage({ image: form }));
      if (uploadBackgroundImage.fulfilled.match(response)) {
        const { url } = response.payload;
        if (url) {
          setValue(FORM_KEYS.BACKGROUND_IMAGE, url);
        }
      }
    }
  };

  // HOOK ---------------------------------------------------------------------

  return {
    handleChange,
  };
};
